import { render } from "./KontaktPthPrizren.vue?vue&type=template&id=01a22559"
import script from "./KontaktPthPrizren.vue?vue&type=script&lang=js"
export * from "./KontaktPthPrizren.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__